import { useState } from "react"
import { Button } from "@components/ui/buttons/Button"


export const AdjustRealChainDialog = ({showDialog, onSubmit}) => {
    const [estChainClicked, setEstChainClicked] = useState(false);
    const [calcChainClicked, setCalcChainClicked] = useState(false);

    const handleCheck = (event) => {
        const { name, checked } = event.target;
        if (name === 'Calc_Chain') {
            setEstChainClicked(false);
            setCalcChainClicked(checked);
        }
        if (name === 'Est_Chain') {
            setCalcChainClicked(false);
            setEstChainClicked(checked)
        }
    }

    

    const handleSubmit = () => {
        let adjustTo = null;
        if(estChainClicked) adjustTo = 'Est_Chain';
        if(calcChainClicked) adjustTo = 'Calc_Chain';
        onSubmit(adjustTo);
        showDialog(false);
    }

    return (
        <>
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-8 rounded-lg max-w-md mx-4 flex flex-col items-center">
                    <p className="text-md text-center font-bold">Which Values Are to Be Used For Real Chain?</p>
                    <div className="mt-6 flex max-[330px]:flex-col flex-row items-center justify-between">
                        <div className="flex space-x-2 mx-3">
                            <label htmlFor="Est_Chain">Estimated Chain</label>
                            <input
                                name='Est_Chain'
                                type="checkbox"
                                checked={estChainClicked}
                                onChange={handleCheck}
                                className="form-checkbox h-5 w-5 text-blue-600 transition duration-200 ease-in-out cursor-pointer"
                            />
                        </div>
                        <div className="flex space-x-2 mx-3">
                            <label htmlFor="Calc_Chain">Calculated Chain</label>
                            <input
                                name='Calc_Chain'
                                type="checkbox"
                                checked={calcChainClicked}
                                onChange={handleCheck}
                                className="form-checkbox h-5 w-5 text-blue-600 transition duration-200 ease-in-out cursor-pointer"
                            />
                        </div>
                    </div>
                    
                    <div>
                        <div className='flex mt-5 space-x-10'>
                            <Button
                                variant="success"
                                onClick={handleSubmit}
                                className='w-max mr-2'
                            >
                                Submit
                            </Button>
                            <Button
                                variant="danger"
                                onClick={() => showDialog(false)}
                                className='w-max mr-2'
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}